import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TextEditorComponent, TitleData, ICONS } from '../../../shared/public-api';
@Component({
  selector: 'admin-title-section',
  templateUrl: './title-section.component.html',
  styleUrls: ['./title-section.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ToggleSwitchModule,
    ButtonModule,
    DialogModule,
    TextEditorComponent,
  ],
})
export class TitleSectionComponent implements OnInit {
  @Input() sectionData: TitleData;
  @Input() componentName: string;
  @Output() sectionDataChange = new EventEmitter<any>();
  displayIcons = false;
  titleIcons = ICONS;

  ngOnInit(): void {
    if (!this.sectionData) {
      this.sectionData = new TitleData();
    }
  }

  selectIcon(icon: string): void {
    this.sectionData.icon = icon;
  }
}
